import React from 'react';
import { Row, Col } from 'antd';

import PageHeaderLoader from '../../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../../components/loaders/cardrowtable';

const EditIntentLoader = () => {
    return (
        <div className="ori-full-width ori-b-pad-10">
            <PageHeaderLoader bottom_bordered container_class="ori-lr-pad-15" />
            <Row>
                <Col xs={24} sm={{ span: 22, offset: 1 }} md={{ span: 16, offset: 0 }} className="ori-pad-10" >
                    <div className="ori-pad-20 ori-b-mrgn-10 ori-box-shadow-light ori-bg-white">
                        <p className="ori-height-md ori-card-loading width4">&nbsp;</p>
                    </div>
                    <div className="ori-tb-pad-10 ori-lr-pad-15 ori-bg-white ori-box-shadow">
                        <CardRowTableLoader hide_table_header row_container_class="ori-bg-default ori-border-default" />
                    </div>
                </Col>
                <Col xs={24} sm={{ span: 22, offset: 1 }} md={{ span: 8, offset: 0 }} className="ori-pad-10" >
                    <p className="ori-height-lg ori-b-mrgn-10 ori-card-loading width4">&nbsp;</p>
                    <p className="ori-height-md ori-tb-mrgn-10 ori-card-loading width2">&nbsp;</p>
                    <div className="ori-tb-pad-10">
                        {
                            [1, 2, 3, 4, 5, 6].map((i) => {
                                return (
                                    <div key={i} className="ori-pad-20 ori-flex-row ori-flex-jsb ori-b-mrgn-10 ori-box-shadow-light ori-bg-white">
                                        <p className="ori-height-md ori-card-loading width4">&nbsp;</p>
                                        <p className="ori-height-md ori-card-loading width1">&nbsp;</p>
                                    </div>
                                );
                            })
                        }
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default (EditIntentLoader);


// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/intents/loaders/index.js